import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import RegistrationProfileBenefitsHeroImage from '../../../../assets/images/registration-profile-benefits-hero.png';
import { rubikTypographyStyles } from '../../../../shared/ui';

const Slide = styled.section.attrs({
  'data-ui': 'onboarding-benefits-slide',
})`
  display: grid;
  gap: ${({ theme }) => theme.scale.px(47)};
`;

const IntroSection = styled.div`
  display: grid;
  gap: ${({ theme }) => theme.scale.px(14)};
`;

const Title = styled.h1`
  ${rubikTypographyStyles};
  margin: 0;
  width: ${({ theme }) => theme.scale.px(341)};
  margin-left: ${({ theme }) => theme.scale.px(31)};
  font-size: ${({ theme }) => theme.scale.px(24)};
  font-weight: 600;
  line-height: ${({ theme }) => theme.scale.px(28)};
`;

const BulletList = styled.ul`
  margin: 0;
  width: ${({ theme }) => theme.scale.px(347)};
  margin-left: ${({ theme }) => theme.scale.px(19)};
  padding-left: ${({ theme }) => theme.scale.px(24)};
`;

const BulletItem = styled.li`
  ${rubikTypographyStyles};
  font-size: ${({ theme }) => theme.scale.px(15)};
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

const HeroImage = styled.img`
  width: ${({ theme }) => theme.scale.px(364)};
  margin-left: ${({ theme }) => theme.scale.px(31)};
  height: auto;
  display: block;
`;

export function BenefitsSlide() {
  const { t } = useTranslation();

  return (
    <Slide>
      <IntroSection>
        <Title>{t('registrationProfileBenefits.title')}</Title>
        <BulletList>
          <BulletItem>
            {t('registrationProfileBenefits.bulletService')}
          </BulletItem>
          <BulletItem>
            {t('registrationProfileBenefits.bulletQrCode')}
          </BulletItem>
          <BulletItem>
            {t('registrationProfileBenefits.bulletJourney')}
          </BulletItem>
        </BulletList>
      </IntroSection>

      <HeroImage
        alt=""
        aria-hidden
        src={RegistrationProfileBenefitsHeroImage}
      />
    </Slide>
  );
}
